import { render, staticRenderFns } from "./ConfigTabs.vue?vue&type=template&id=e19831ca&scoped=true&"
import script from "./ConfigTabs.vue?vue&type=script&lang=js&"
export * from "./ConfigTabs.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTabs.vue?vue&type=style&index=0&id=e19831ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19831ca",
  null
  
)

export default component.exports